import { send } from './requests';

/**
 * @typedef EmployeePosition
 * @property {number|undefined} vertical
 * @property {number|undefined} horizontal
 */

/**
 * @typedef EmployeeType
 * @property {number} id
 * @property {string} name
 * @property {string} role
 * @property {EmployeePosition} position
 * @property {string} photo
 */

/**
 * Get list of employees
 * @returns {Promise<EmployeeType[]>}
 */
const getEmployees = async () => (await send('employees')).data.data;

/**
 * find a employee by Id
 * @param {number} id
 * @returns {Promise<EmployeeType>}
 */
const getEmployee = async (id) => (await send(`employees/${id}`)).data.data;

/**
 * @param {number} id the user you want to delete
 */
const deleteEmployee = (id) => send(`employees/${id}`, { method: 'DELETE' });

const createEmployee = (name, role, photo) => {
  const fd = new FormData();
  fd.append('name', name);
  fd.append('role', role);
  fd.append('photo', photo);
  return send('employees', {
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: fd
  });
};

/**
 * @param {{[id: number]: string}} positions
 */
const moveEmployees = (positions) =>
  send('employees/positions', { method: 'PUT', data: positions });

/**
 *
 * @param {number} id
 * @param {string|undefined} name
 * @param {string|undefined} role
 * @param {Blob|undefined} photo
 * @returns {Promise<import('axios').AxiosResponse>}
 */
const updateEmployee = (id, name, role, photo) => {
  const fd = new FormData();
  if (name) fd.append('name', name);
  if (role) fd.append('role', role);
  if (photo) fd.append('photo', photo);

  return send(`employees/${id}`, {
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: fd
  });
};

export { getEmployees, deleteEmployee, createEmployee, getEmployee, updateEmployee, moveEmployees };
